import { useState, useEffect } from 'react';

const defaultState = {
  isStandaloneStickyAtbEnabled: false,
  isStickyAtbWidgetEnabled: false,
};

const splitTestState = {
  a: defaultState,
  b: { isStandaloneStickyAtbEnabled: true, isStickyAtbWidgetEnabled: true },
  c: { isStandaloneStickyAtbEnabled: false, isStickyAtbWidgetEnabled: true },
};

function getStateForTest(stickyAtbDesktopExperienceTest) {
  return splitTestState[stickyAtbDesktopExperienceTest] || defaultState;
}

export default function useStickyAtbFeatureTest(
  hasStickyAddToBagDesktopEnabled,
  stickyAtbDesktopExperienceTest,
) {
  const [stickyAtbDesktopState, setStickyAtbDesktopState] = useState(
    defaultState,
  );

  useEffect(() => {
    const updatedStickyAtbState = hasStickyAddToBagDesktopEnabled
      ? getStateForTest(stickyAtbDesktopExperienceTest)
      : defaultState;
    setStickyAtbDesktopState(updatedStickyAtbState);
  }, [hasStickyAddToBagDesktopEnabled, stickyAtbDesktopExperienceTest]);

  return stickyAtbDesktopState;
}
